<template>
        <span class="exportData20210907">
                <el-button type="warning" plain size="small" icon="el-icon-plus" @click="exportExcelSelection">
                        导出
                </el-button>
                <el-dialog title="导出数据" class="exportDataDialog20210907" :visible.sync="exportExcelSelectionBoxFlag" append-to-body width="45%"
                           :close-on-click-modal="false">
                        <div class="cell">
                                <div class="cell-label">
                                        要导出的数据
                                </div>
                                <div class="cell-value" >
                                        <el-radio v-model="exportExcelSelectionRadio" label="1">导出全部数据</el-radio>
                                        <el-radio v-model="exportExcelSelectionRadio" label="2">导出已选数据</el-radio>
                                </div>
                        </div>
                        <!-- <div class="cell">
                                <div class="cell-label">
                                        模板名称
                                </div>
                                <div class="cell-value" >
                                       <el-select
                                                v-model="templateName"
                                                placeholder="请选择模板"
                                                @change="modulTypeChange"

                                       >
                                                <el-option
                                                        v-for="item in personalModulTypeList"
                                                        :key="item.id"
                                                        :label="item.templateName"
                                                        :value="item.templateName">
                                                </el-option>
                                        </el-select>
                                        <span class="setting-button">
                                                <el-button  size="small" @click="showTemplate = !showTemplate" style="position: absolute; z-index:5000">设置</el-button>
                                                <div class="sharp" v-if="showTemplate"></div>
                                        </span>

                                </div>
                        </div>
                        <div class="air" v-if="showTemplate">
                                <div style="height:1px"></div>
                                <div class="content">
                                        <div>
                                                要导出字段
                                        </div>
                                        <div style="margin-top:10px;">
                                                <el-select  v-model="fieldList" style="width:100%;" multiple placeholder="请选择字段">
                                                        <el-option
                                                                v-for="item in allModulTypeList"
                                                                :key="item.key"
                                                                :label="item.value"
                                                                :value="item.key">
                                                        </el-option>
                                                </el-select>
                                        </div>
                                        <div class="template">

                                                <div class="template-label">
                                                         模板名称
                                                </div>
                                                <el-input v-model="modulTypeName"  show-word-limit maxlength="20"></el-input>
                                                <el-button size="small" type="primary" @click="saveModulType" style="">保存</el-button>
                                                <el-button size="small" @click="deleteModulType">删除</el-button>
                                        </div>
                                </div>



                        </div> -->

                        <template slot="footer">
                                <div style="text-align:center;">
                                        <el-button type="primary" @click="exportExcel">导出</el-button>
                                        <el-button type="info" @click="exportExcelSelectionBoxFlag=false">取消</el-button>
                                </div>
                        </template>


                </el-dialog>

        </span>
</template>
<script>
import {
        saveExportDataModulType,//保存个人模板
        removeExportDataModulType,//删除个人模板
        getListByModuleType,//获取个人模板结合
        getListByModuleTypeAll,//获取全集字段集合
} from '@/api/wel/home.js';
export default {
        props:{
                // 表格列配置
                column:{
                        type:Array,
                        default:() => {
                                return [];
                        },
                },
                // 类型
                moduleType:{
                        type:Number,
                        default:0,
                },
                // 导出excel的方法
                getSupplierExportExcel:{
                        type:Function,
                }
        },
        data(){
                return{
                        showTemplate:false,
                        visible:true,
                        fieldList:[],
                        modulTypeId:'',
                        templateName:'',
                        modulTypeName:'',
                        exportExcelSelectionBoxFlag:false,
                        exportExcelSelectionRadio:'1',//要导出的数据
                        personalModulTypeList: [],
                        allModulTypeList:[],
                                value: ''
                }
        },
        created(){
                this.initData();
        },
        methods:{
                // 初始化数据
                async initData(){
                        await this.getListByModuleType('init');
                        getListByModuleTypeAll({moduleType:this.moduleType}).then(res=>{
                                this.allModulTypeList = res.data;
                        })
                },
                // 加载模板下拉框数据
                async getListByModuleType(type){
                        await getListByModuleType({moduleType:this.moduleType}).then(res=>{
                                this.personalModulTypeList = res.data;
                                if(type == 'remove' || type == "init"){
                                        this.templateName =  this.personalModulTypeList[0]?this.personalModulTypeList[0].templateName:'';
                                        this.modulTypeName =  this.personalModulTypeList[0]?this.personalModulTypeList[0].templateName:'';
                                        this.fieldList = this.personalModulTypeList[0]?this.personalModulTypeList[0].personalConfig.split(","):[];
                                }
                        })
                },
                // 切换模板
                modulTypeChange(e){
                        this.personalModulTypeList.forEach(ele => {
                                if(ele.templateName == e ){
                                        this.modulTypeName = ele.templateName;
                                        this.fieldList = ele.personalConfig.split(",");
                                }
                        });
                },
                // 保存模板
                saveModulType(){
                        if(this.modulTypeName == this.personalModulTypeList[0].templateName){
                                this.$message({
                                        message:`【${this.modulTypeName}】 不可操作哟！` ,
                                        type: 'warning'
                                });
                                return;
                        }
                        if(this.modulTypeName==""){
                                this.$message({
                                        message:'请输入 【模板名称】！',
                                        type: 'warning'
                                });
                                return;
                        }
                        let personalConfig = this.fieldList.join(',');
                        let form = {
                                templateName:this.modulTypeName,
                                moduleType:this.moduleType,
                                personalConfig:personalConfig,
                        };
                        saveExportDataModulType(form).then(res=>{
                                if(res.success){
                                        this.getListByModuleType('save');
                                        this.templateName = this.modulTypeName;
                                        this.$message({
                                                message: '操作成功!',
                                                type: 'success'
                                        });
                                }

                        })
                },
                // 删除模板
                deleteModulType(){
                        if(this.modulTypeName == this.personalModulTypeList[0].templateName){
                                this.$message({
                                        message:`【${this.modulTypeName}】 不可操作哟！` ,
                                        type: 'warning'
                                });
                                return;
                        }
                        if(this.modulTypeName==""){
                                this.$message({
                                        message:'请输入 【模板名称】！',
                                        type: 'warning'
                                });
                                return;
                        }
                        let form = {
                                templateName :this.modulTypeName,
                                moduleType:this.moduleType,
                        }
                        removeExportDataModulType(form).then(res=>{
                                if(res.success){
                                        this.$message({
                                                message: '操作成功!',
                                                type: 'success'
                                        });
                                        this.getListByModuleType('remove');
                                }
                        })
                },
                // 导出
                exportExcel(){
                        let configExport = this.fieldList.join(",");
                        let form = {
                                projectId:this.projectId,
                                configExport:configExport,
                                exportExcelSelectionRadio:this.exportExcelSelectionRadio
                        };
                        this.$emit("exportExcel", form);
                },
                // 打开弹窗
                exportExcelSelection(){
                        this.exportExcelSelectionBoxFlag = true;
                }
        }
}
</script>
<style lang="scss">
.exportDataDialog20210907{
        .el-input__icon{
                line-height: 32px;
        }
        .el-radio{
                line-height: 2;
        }
        .cell{
                display: flex;
                height: 40px;
                margin: 10px;
                align-items: center;
                .cell-label{
                        width: 100px;
                        flex-shrink: 0;
                        flex-grow: 0;
                }
                .cell-value{
                        // padding:0 1rem;
                        flex-shrink: 1;
                        flex-grow: 1;
                }
        }
        .air{
                // margin: 20px 0;
                background-color: #eee;
                // padding: 15px;
                width: 100%;
                border: 1px solid #ddd;
                background: #fafafa;
        }
        .setting-button{
                position: relative;
                margin-left: 15px;
                .sharp{
                        width: 0px;
                        height: 0px;
                        border:20px solid #fafafa;
                        border-top-color: transparent;
                        border-left-color: transparent;
                        border-right-color: transparent;
                        z-index: 4000;
                        position: absolute;
                        top: 6px;
                        right: -46px;
                }
        }
        .content{
                margin: 20px;
                .template{
                        margin-top: 30px;
                        display: flex;
                        .template-label{
                                width: 130px;
                                height: 30px;
                                line-height: 32px;
                                text-align: center;
                                background-color: #eee;
                                border: 1px solid #dcdcdc;
                                border-radius: 2px 0px 0px 2px;
                                border-left-width: 1px;
                        }
                }
        }

}

</style>
